// eslint-disable-next-line import/no-anonymous-default-export
export default {
  SET_LANGUAGE: 'SET_LANGUAGE',
  CLEAR_LANGUAGE: 'CLEAR_LANGUAGE',
};
